import { useRef, useState } from "react";
import { useFrame } from "@react-three/fiber";
import { featuresContext as features } from "./features";
import { animated, easings, useSpring } from "@react-spring/three";

const Cursor = ({ isHovering, texture, bumpMap }) => {
  const cursorRef = useRef();
  const [position, setPosition] = useState([0, 0, 0]);
  const [mouseMoving, setMouseMoving] = useState(true);

  useFrame(({ mouse, viewport }) => {
    const x = (mouse.x * viewport.width) / 2;
    const y = (mouse.y * viewport.height) / 2;
    setPosition([x, y, 0]);
    const hasMouseMoved = x !== position[0] || y !== position[1];
    if (hasMouseMoved) {
      setMouseMoving(true);
    } else {
      setMouseMoving(false);
    }
  });

  const springs = useSpring({
    config: {
      duration: 250,
      easing: easings.easeOutQuart,
    },
    size: isHovering ? 0.8 : 0.125,
  });

  const { opacity } = useSpring({
    config: {
      duration: mouseMoving ? 0 : 2000,
    },
    opacity: isHovering ? 1 : mouseMoving ? 0.7 : 0,
  });

  const { color } = useSpring({
    config: {
      duration: 500,
      easing: easings.easeInOutCubic,
    },
    color: isHovering
      ? `hsl(${features.baseHue}, 100%, 70%)`
      : `hsl(${features.baseHue}, 100%, 50%)`,
  });

  return (
    <group ref={cursorRef} position={position}>
      <animated.mesh scale={springs.size}>
        <sphereGeometry args={[1, 32, 32]} />
        <animated.meshBasicMaterial
          transparent
          opacity={opacity}
          color={color}
        />
      </animated.mesh>
    </group>
  );
};

export default Cursor;
